import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { preloadMarketingRoute } from './MarketingRoutes.tsx'
import { initAnalyticsClickTracking } from './utils/analytics.ts'

initAnalyticsClickTracking()

const bootstrap = async () => {
  const root = document.getElementById('root')!
  const isSecureRoute = /^\/(?:app|auth)(?:\/|$)/.test(window.location.pathname)

  // Public routes are prerendered. Fetch only the matching page module before
  // hydration so React can reuse that HTML without bundling every other page.
  if (root.hasChildNodes() && !isSecureRoute) {
    await preloadMarketingRoute(window.location.pathname)
  }

  const app = <App />

  if (root.hasChildNodes() && !isSecureRoute) {
    // The marketing route modules are split from the application shell. React's
    // lazy boundary cannot hydrate the eager server tree reliably, even after
    // its module has been prefetched. Preserve the prerender for first paint and
    // crawlers, then mount the interactive tree once the matching route is ready.
    root.replaceChildren()
    createRoot(root).render(app)
  } else if (root.hasChildNodes()) {
    hydrateRoot(root, app)
  } else {
    createRoot(root).render(app)
  }
}

void bootstrap()
